<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import lodash from 'lodash';
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowNewPatientsTotal',
    extends: TableRowBase,
    data() {
      return {
        fields: [
          'num_new_patients_scit',
          'num_new_patients_slit',
        ],
      };
    },
    computed: {
      actualValueRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.curMonth[field])
        }, 0);
      },
      benchmarkValueRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.benchmarkMonth[field])
        }, 0);
      },
      previousValueRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.prevYearMonth[field])
        }, 0);
      },
    },
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + this.getYtdByField(yearObj, field, throughMonth)
        }, 0);
      },
    },
  };
</script>
